import * as React from 'react'
import {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {api} from '../api/api'
import '../css/events.css'
import {tagger} from '../util/util'
import {useTranslation} from 'react-i18next'

const Events = () => {

    const {t} = useTranslation('landing')

    const [events, setEvents] = useState([])

    const loadData = async () => {
        const eventsResult = await api.events()
        setEvents(eventsResult.results)
    }

    useEffect(() => {loadData()}, [])

    const renderEvent = (event, index) => {
        return (
            <div key={event._id} className="event">
                <span>
                    <div className="event-image" style={{backgroundImage: 'url(' + encodeURI(event.image) + ')'}} />
                    <div className="event-description">
                        <div>{event.name}</div>
                        <div className="event-location">{event.dateString} - {event.location}</div>
                    </div>
                </span>
                <span className="event-dot"><img src="https://static.persona.ly/images/events/oval-copy-4.svg" /></span>
                <span className="event-date not-tablet not-mobile" style={{backgroundImage: 'url(https://static.persona.ly/images/events/' + index + '.svg)'}}><div>{event.dateString}</div></span>
            </div>
        )
    }

    const renderEventList = () => events.map((event: any, index) => renderEvent(event, index + 1))

    return (
        <div className="events"><p className="muli">{tagger(t('Upcoming Events'), 'accent-text')}</p>
            <div>
                {renderEventList()}
            </div>
            <Link to="about#contact"><button className="button-blue large">{t('schedule a meeting')}</button></Link>
        </div>
    )
}

export default Events


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/events.tsx